import { useState } from "react";
import { Pencil, Save, X } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";

const WorkExperience = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [experiences, setExperiences] = useState([
        {
            id: 1,
            companyName: "Infisuite",
            jobDescription: "Job Description",
            fromDate: "2025-03-03",
            toDate: "2025-04-04",
        },
    ]);

    const handleChange = (id, e) => {
        const { name, value } = e.target;
        setExperiences((prevExperiences) =>
            prevExperiences.map((exp) =>
                exp.id === id ? { ...exp, [name]: value } : exp
            )
        );
    };

    const handleSave = () => {
        setIsEditing(false);
    };

    const handleAddRow = () => {
        setExperiences([
            ...experiences,
            {
                id: experiences.length + 1,
                companyName: "",
                jobDescription: "",
                fromDate: "",
                toDate: "",
            },
        ]);
    };

    const handleDeleteRow = (id) => {
        setExperiences(experiences.filter((exp) => exp.id !== id));
    };

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Work Experience</h5>
                <div>
                    {isEditing && (
                        <button onClick={handleSave} className="btn btn-success btn-sm me-2">
                            <Save size={18} className="me-1" /> Save
                        </button>
                    )}
                    <button onClick={() => setIsEditing(!isEditing)} className="border-0 bg-transparent">
                        {isEditing ? <X className="text-danger" size={20} /> : <Pencil className="text-primary" size={20} />}
                    </button>
                </div>
            </div>

            <div className="card-block">
                <div className="table-responsive">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Company Name</th>
                                <th>Job Description</th>
                                <th>From</th>
                                <th>To</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {experiences.map((exp) => (
                                <tr key={exp.id}>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                name="companyName"
                                                className="form-control input-me f-14"
                                                value={exp.companyName}
                                                onChange={(e) => handleChange(exp.id, e)}
                                            />
                                        ) : (
                                            <p className="mb-0 f-13">{exp.companyName}</p>
                                        )}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                name="jobDescription"
                                                className="form-control input-me f-14"
                                                value={exp.jobDescription}
                                                onChange={(e) => handleChange(exp.id, e)}
                                            />
                                        ) : (
                                            <p className="mb-0 f-13">{exp.jobDescription}</p>
                                        )}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="date"
                                                name="fromDate"
                                                className="form-control input-me f-14"
                                                value={exp.fromDate}
                                                onChange={(e) => handleChange(exp.id, e)}
                                            />
                                        ) : (
                                            <p className="mb-0 f-13">{exp.fromDate}</p>
                                        )}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="date"
                                                name="toDate"
                                                className="form-control input-me f-14"
                                                value={exp.toDate}
                                                onChange={(e) => handleChange(exp.id, e)}
                                            />
                                        ) : (
                                            <p className="mb-0 f-13">{exp.toDate}</p>
                                        )}
                                    </td>
                                    <td align="right">
                                        <button className="btn text-info p-0 f-12 me-3">
                                            <FontAwesomeIcon icon={faUpload} className="" />
                                        </button>
                                        <button className="btn text-danger p-0 f-12" onClick={() => handleDeleteRow(exp.id)}>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <button className="btn btn-primary btn-sm mt-2" onClick={handleAddRow}>
                        <FontAwesomeIcon icon={faPlus} /> Add More
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WorkExperience;
